import React from "react";
import Layout from "../layout/Layout";
import { Button, Card, Col, Flex, Row, Typography } from "antd";
import { RollbackOutlined } from "@ant-design/icons";
const { Title, Text } = Typography;

const QAQCMixDesignsMenu = ({ history }) => {
	const showPsiList = () => {
		history.push("/psi/list");
	};

	const showCogList = () => {
		history.push("/cog/list");
	};

	const showMillTestCertificates = () => {
		history.push("/certificates/list");
	};

	const showSubmitals = () => {
		history.push("/submitals/list");
	};

	const CustomDashboard = () => {
		return (
			<div>
				<Row gutter={[16, 16]}>
					{(localStorage.getItem("email") === "gg@57xgroup.com" ||
						localStorage.getItem("email") === "ss@57concrete.com" ||
						localStorage.getItem("email") === "ec@57concrete.com" ||
						localStorage.getItem("email") === "pc@57concrete.com" ||
						localStorage.getItem("email") === "jc@57concrete.com" ||
						localStorage.getItem("email") === "jp@57concrete.com" ||
						localStorage.getItem("email") === "eliud@gmail.com") && (
						<Col span={8}>
							<Card
								bordered
								style={{
									backgroundColor: "rgb(22, 63, 124)",
									cursor: "pointer",
								}}
								onClick={showPsiList}
							>
								<Flex align="center" justify="center" vertical>
									<Title level={2} style={{ color: "white" }}>
										Product Setup
									</Title>
									<Text style={{ color: "white" }}>QA/QC Product List</Text>
								</Flex>
							</Card>
						</Col>
					)}
					{(localStorage.getItem("email") === "gg@57xgroup.com" ||
						localStorage.getItem("email") === "ss@57concrete.com" ||
						localStorage.getItem("email") === "ec@57concrete.com" ||
						localStorage.getItem("email") === "pc@57concrete.com" ||
						localStorage.getItem("email") === "jc@57concrete.com" ||
						localStorage.getItem("email") === "jp@57concrete.com" ||
						localStorage.getItem("email") === "eliud@gmail.com") && (
						<Col span={8}>
							<Card
								bordered
								style={{
									backgroundColor: "rgb(30, 28, 142)",
									cursor: "pointer",
								}}
								onClick={showCogList}
							>
								<Flex align="center" justify="center" vertical>
									<Title level={2} style={{ color: "white" }}>
										Cogs
									</Title>
									<Text style={{ color: "white" }}>Raw Materials</Text>
								</Flex>
							</Card>
						</Col>
					)}
					{(localStorage.getItem("email") === "gg@57xgroup.com" ||
						localStorage.getItem("email") === "ss@57concrete.com" ||
						localStorage.getItem("email") === "ec@57concrete.com" ||
						localStorage.getItem("email") === "pc@57concrete.com" ||
						localStorage.getItem("email") === "jc@57concrete.com" ||
						localStorage.getItem("email") === "jp@57concrete.com" ||
						localStorage.getItem("email") === "eliud@gmail.com") && (
						<Col span={8}>
							<Card
								bordered
								style={{
									backgroundColor: "rgb(41, 38, 171)",
									cursor: "pointer",
								}}
								onClick={showMillTestCertificates}
							>
								<Flex align="center" justify="center" vertical>
									<Title level={2} style={{ color: "white" }}>
										Mill Test Certificates
									</Title>
									<Text style={{ color: "white" }}>Cement</Text>
								</Flex>
							</Card>
						</Col>
					)}
					{(localStorage.getItem("email") === "gg@57xgroup.com" ||
						localStorage.getItem("email") === "ss@57concrete.com" ||
						localStorage.getItem("email") === "rl@57concrete.com" ||
						localStorage.getItem("email") === "jh@57concrete.com" ||
						localStorage.getItem("email") === "dmad@57concrete.com" ||
						localStorage.getItem("email") === "jp@57concrete.com" ||
						localStorage.getItem("email") === "ec@57concrete.com" ||
						localStorage.getItem("email") === "pc@57concrete.com" ||
						localStorage.getItem("email") === "jc@57concrete.com" ||
						localStorage.getItem("email") === "jp@57concrete.com" ||
						localStorage.getItem("email") === "eliud@gmail.com") && (
						<Col span={12}>
							<Card
								bordered
								style={{
									backgroundColor: "rgb(57, 55, 180)",
									cursor: "pointer",
								}}
								onClick={showSubmitals}
							>
								<Flex align="center" justify="center" vertical>
									<Title level={2} style={{ color: "white" }}>
										Submitals
									</Title>
									<Text style={{ color: "white" }}>Approved Mix Designs</Text>
								</Flex>
							</Card>
						</Col>
					)}
				</Row>
			</div>
		);
	};

	const goBack = () => {
		history.goBack();
	};

	return (
		<Layout title="QA/QC Mix Designs" description="Menu">
			<Flex vertical gap={16}>
				<Button
					type="primary"
					size="large"
					icon={<RollbackOutlined />}
					onClick={goBack}
				/>
				<CustomDashboard />
			</Flex>
		</Layout>
	);
};

export default QAQCMixDesignsMenu;
